import type { JSX } from 'preact';
import type { BoatDocument } from '../../sim/boat/index.ts';
import { BoatSideArt } from './sideArt.tsx';
import './trialCard.css';

function formatMetres(value: number): string {
  const rounded = Math.round(value * 10) / 10;
  return Number.isInteger(rounded) ? `${rounded} m` : `${rounded.toFixed(1)} m`;
}

function SideProfile({ boat }: { boat: BoatDocument }): JSX.Element {
  return (
    <figure
      class="boat-card-profile"
      aria-label={`Length ${formatMetres(boat.lengthM)}, keel ${formatMetres(boat.draftM)}`}
    >
      <span class="boat-card-length">{formatMetres(boat.lengthM)}</span>
      <div class="boat-card-pane">
        <BoatSideArt boat={boat} className="boat-card-art" />
        <span class="boat-card-draft">{formatMetres(boat.draftM)}</span>
      </div>
    </figure>
  );
}

/** Editor card for the open hull: name and side view. Telemetry docks under it. */
export function BoatTrialCard({ boat }: { boat: BoatDocument }): JSX.Element {
  return (
    <aside class="boat-card ui-panel ui-chrome" aria-label={boat.name}>
      <h2 class="boat-card-name">{boat.name}</h2>
      <SideProfile boat={boat} />
    </aside>
  );
}
